<select-gp-for-cw
    type="chordProgression"
    subtitle=""
    [selectGPForCW]="selectGPForCW.bind(this)"></select-gp-for-cw>
